const FEEDBACK_CREATED = 'FEEDBACK_CREATED';
const FEEDBACK_OPTION_CHANGED = 'FEEDBACK_OPTION_CHANGED';
const FEEDBACK_COMMENT_CHANGED = 'FEEDBACK_COMMENT_CHANGED';

export { 
    FEEDBACK_CREATED,
    FEEDBACK_OPTION_CHANGED,
    FEEDBACK_COMMENT_CHANGED
};